module.exports = __webpack_public_path__ + "img/bmw.2db56f4a.svg";